module.exports = __webpack_public_path__ + "static/media/hero-generic.1d8f7a65.png";